<template>
  <div class="function-modules" :class="{ 'locale-zh-CN': isZhLocale }">
    <div class="modules-container">
      <div 
        v-for="module in visibleModules" 
        :key="module.id" 
        class="module-item"
        :class="{ active: isActiveModule(module) }"
        @click="handleModuleClick(module)"
      >
        <div class="module-icon">
          <img :src="getSafeImageLocal(module.icon)" :alt="module.name" @error="onImgError" />
        </div>
        <div class="module-info">
          <div class="module-name">{{ module.name }}</div>
          <div v-if="isZhLocale && module.enName" class="module-en-name">{{ module.enName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSafeImage, handleImgError } from '@/utils/imageFallback'
import { getText } from '@/utils/i18nText'
import { filterNavModules } from '@/config/homeConfig'

export default {
  name: 'ModuleList',
  props: {
    // 模块列表数据
    modules: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    visibleModules() {
      return filterNavModules(this.modules)
    },
    // 当前路由路径
    currentPath() {
      return this.$route.path
    }
  },
  methods: {
    getSafeImageLocal(src) {
      return getSafeImage(src)
    },
    onImgError(event) {
      handleImgError(event)
    },
    // 判断模块是否激活
    isActiveModule(module) {
      const routeMap = {
        'home': '/index',
        'innovation': '/innovation',
        'supply': '/supply-demand',
        'evaluation': '/value-assessment',
        'manager': '/manager',
        'transaction': '/transaction',
        'talent': '/talent',
        'enterprise': '/agriculture-enterprise',
        'policy': '/policy',
        'service': '/innovation-service'
      }
      
      const modulePath = routeMap[module.id] || module.link
      return this.currentPath === modulePath
    },
    
    // 功能模块点击
    handleModuleClick(module) {
      console.log(getText('moduleList.consoleModuleClick', '[ModuleList] click:'), module.name)
      
      // 根据模块ID跳转
      const routeMap = {
        'home': '/index',
        'innovation': '/innovation',
        'supply': '/supply-demand',
        'evaluation': '/value-assessment',
        'manager': '/manager',
        'transaction': '/transaction',
        'talent': '/talent',
        'enterprise': '/agriculture-enterprise',
        'policy': '/policy',
        'service': '/innovation-service'
      }
      
      const route = routeMap[module.id] || module.link
      if (route) {
        this.$router.push(route)
      }
      
      // 同时向父组件发送事件
      this.$emit('module-click', module)
    }
  }
}
</script>

<style lang="scss" scoped>
// 功能模块
.function-modules {
  width: 1920px;

  position: relative;
  z-index: 3;

  .modules-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 12px 73px;
    box-sizing: border-box;

    .module-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      transition: background-image 0.3s, box-shadow 0.3s;
      padding: 10px 12px;
      border-radius: 8px;
      box-sizing: border-box;

      &:hover:not(.active) {
        transform: translateY(-1px);
      }

      &:hover,
      &.active {
        background-image: url('~@/assets/img/tab-selected-bg.png');
        background-size: 100% 100%;
        background-position: center center;
        background-repeat: no-repeat;

        .module-icon {
          background: transparent;

          img {
            transform: scale(1.1);
          }
        }
      }

      &.active {
        transform: none;
      }

      .module-icon {
        width: 62px;
        height: 61px;
        background: transparent;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        flex-shrink: 0;
        transition: all 0.3s;

        img {
          width: 62px;
          height: 61px;
          object-fit: contain;
          transition: transform 0.3s;
        }
      }

      .module-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .module-name {
          font-size: 15px;
          color: #333;
          font-weight: 500;
          line-height: 1.3;
          margin-bottom: 2px;
        }

        .module-en-name {
          font-size: 9px;
          color: #C7C2A5;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          line-height: 1;
        }
      }
    }
  }
}

.function-modules.locale-zh-CN {
  .modules-container .module-item .module-info {
    .module-name {
      font-size: 20px;
    }

    .module-en-name {
      font-size: 12px;
    }
  }
}
</style>
